Pegasus.ApplicationController = Ember.Controller.extend({
  publish: function(event){
    $( this ).trigger(event);
  },
  shouldSizeScrollbar: 0,
  slideValue: 100,
  hasWeblink: function(){
    return !!( Pegasus.Weblink.find().get('length') );
  }.property('content.html'),
  hasShare: function(){
    return !!( Pegasus.SocialShare.find().get('length') );
  }.property('content.html'),
  shouldShowImageReplacer: false,
  shouldShowImageImage: false,
  toggleHelpMenu: function(){
    this.toggleProperty('shouldShowHelpMenu');
  },
  documentsLoaded: false
});
